import React from "react";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
import i18next from "i18next";
import { GlobalContext } from "Global/Context/GlobalContextProvider";
import { useContext } from "react";

const ErrorSupportForAllMui = ({ label }) => {
  const languageArray = useContext(GlobalContext)?.LanguageArray;

  return (
    <React.Fragment>
      <sub
        style={{
          textAlign: i18next.language === "en" ? "left" : "right",
          color: "#D32F2F",
          margin: ".3em",
          marginRight: "1em",
          fontSize: "12px",
        }}
      >{`${FindLangKey(
        "general-form-component-error-field",
        languageArray
      )} ${label}  ${FindLangKey(
        "general-form-component-error-fill-the",
        languageArray
      )} `}</sub>
    </React.Fragment>
  );
};

export default ErrorSupportForAllMui;
